import { ChakraHStack, FireflyButton, ModalV2, Text } from '@equip.health/ui';

interface MessageModalProps {
  dismissVariant?: 'accent.critical' | 'primary';
  id: string;
  isOpen: boolean;
  onCancel: () => void;
  subTitle: string;
  title: string;
}

const modalArgs = {
  bodyStyle: {
    overflow: 'visible',
  },
  footerStyle: {
    padding: '0px',
  },
  titleStyle: {
    flex: '1 0 0',
    padding: '0px',
  },
};

const MessageModal = ({
  dismissVariant,
  id,
  isOpen,
  onCancel,
  subTitle,
  title,
}: MessageModalProps) => {
  return (
    <ModalV2
      footerContent={
        <ChakraHStack width="100%">
          <FireflyButton id={`${id}-button`} onClick={onCancel} variant={dismissVariant}>
            Dismiss
          </FireflyButton>
        </ChakraHStack>
      }
      id={`${id}`}
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      {...modalArgs}
      size="lg"
    >
      <Text id={`${id}-subtitle`} variant="body">
        {subTitle}
      </Text>
    </ModalV2>
  );
};

export default MessageModal;
